export const dropDownToggle = () => {
    var dropDownArray = document.body.querySelectorAll(".blockdropdown h2");
    Array.from(dropDownArray).forEach((element) => {
        element.addEventListener("click", (e) => {
            console.log('click');
            element.closest(".blockdropdown").classList.toggle("dropped");
        });
    });
};